import styled from 'styled-components';

const SectionSubHead = styled.div`
  background-color: ${(props): string => props.theme.colors.marinoBlue};
  padding: ${(props): string =>
    `${props.theme.spaces.sm} ${props.theme.spaces.xl}`};

  color: ${(props): string => props.theme.colors.pureWhite};
`;

export { SectionSubHead };
